<template>
  <div>
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6"
        color="primary"
        :size="50"
        indeterminate
      />
    </div>

    <div
      class="mt-4"
      v-show="dataLoaded"
    >
      <TitleCard
        :is-show-mode="isShowMode"
        :is-process-mode="isProcessMode"
        :is-edit-mode="isEditMode"
        :disabled="invalid"
        :saveLoading="saveBtnLoading"
        :selected-item="scientificPracticalEvent"
        :is-no-changes="isNoChanges"
        @save="saveScientificPracticalEvent"
      />

      <v-row
        class="mb-0 mt-2"
        style="margin-right: -14px"
      >
        <v-col
          ref="workList"
          cols="12"
          class="pt-1 pb-2 pr-2 overflow-auto"
        >
          <WorkTitleCard :title="this.workTypeRusName(workTypeName.ScientificPracticalEvent)" />

          <ScientificPracticalEventCard
            class="mt-4"
            title="Основная информация"
            :is-show-mode="isShowMode"
            :selected-item.sync="scientificPracticalEvent"
            @updateInvalid="updateScientificPracticalEventInvalid"
          />

          <CommentCard
            v-if="Boolean(scientificPracticalEvent.commonWork.comment)"
            class="mt-4"
            :comment="scientificPracticalEvent.commonWork.comment"
          />

          <CreatorCard :creator-name="scientificPracticalEvent.commonWork.creator.fullName" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { scientificPracticalEventApi } from '@/api'
import TitleCard from '@/components/Works/elements/TitleCard'
import CommentCard from '@/components/Works/elements/CommentCard.vue'
import { mapActions, mapGetters } from 'vuex'
import { workListHeight } from '@/mixins/workListHeight'
import { dictionaryNames, workMode, workTypeName } from '@/scripts/consts'
import WorkTitleCard from '@/components/Works/elements/WorkTitleCard.vue'
import CreatorCard from '@/components/Works/elements/CreatorCard.vue'
import { ScientificPracticalEvent } from '@/models/works/ScientificPracticalEvent'
import ScientificPracticalEventCard from '@/components/Works/ScientificPracticalEvent/ScientificPracticalEventCard.vue'

export default {
  name: 'ScientificPracticalEventPage',

  metaInfo() {
    return {
      title: this && this.workTypeRusName(workTypeName.ScientificPracticalEvent)
    }
  },

  components: {
    ScientificPracticalEventCard,
    CreatorCard,
    WorkTitleCard,
    CommentCard,
    TitleCard
  },

  mixins: [workListHeight],

  created() {
    this.isShowMode = this.$route.params.mode === workMode.Show
    this.isProcessMode = this.$route.params.mode === workMode.Process
    this.isEditMode = this.$route.params.mode === workMode.Edit
    this.getData()
  },

  data: () => ({
    scientificPracticalEvent: new ScientificPracticalEvent(),
    dataLoaded: false,
    isShowMode: false,
    isEditMode: false,
    isProcessMode: false,
    scientificPracticalEventInvalid: false,
    saveBtnLoading: false,
    isNoChanges: true
  }),

  computed: {
    workTypeName() {
      return workTypeName
    },
    ...mapGetters('workTypes', ['workTypeByName', 'workTypeRusName']),

    invalid() {
      return this.scientificPracticalEventInvalid
    }
  },

  methods: {
    ...mapActions('dictionaries', ['getDictionaries']),
    ...mapActions('workTypes', ['getWorkTypes']),

    async getData() {
      if (!this.isShowMode)
        await this.getDictionaries([
          dictionaryNames.Department,
          dictionaryNames.EventType,
          dictionaryNames.EventFormat,
          dictionaryNames.Year
        ])
      await this.getWorkTypes()
      await this.getScientificPracticalEvent()
      this.dataLoaded = true
      this.isNoChanges = true
    },

    async getScientificPracticalEvent() {
      try {
        if (this.$route.params?.id !== '0') {
          const data = this.$route.params?.id ? await scientificPracticalEventApi.get(this.$route.params?.id) : null
          if (data) this.scientificPracticalEvent = new ScientificPracticalEvent(data)
        }
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Не удалось получить данные по работе')
      }
    },

    async saveScientificPracticalEvent(isThrowError = false) {
      try {
        this.saveBtnLoading = true

        if (!this.scientificPracticalEvent.id)
          this.scientificPracticalEvent.commonWork.workType = this.workTypeByName(workTypeName.ScientificPracticalEvent)

        const body = this.scientificPracticalEvent.getForAPI()

        const data = this.scientificPracticalEvent.id
          ? await scientificPracticalEventApi.update(body)
          : await scientificPracticalEventApi.create(body)

        if (!this.scientificPracticalEvent.id)
          await this.$router.replace('/works/scientificPracticalEvent/edit/' + data.id)

        this.scientificPracticalEvent = new ScientificPracticalEvent(data)
        this.$toast.info('Работа успешно сохранена')
        queueMicrotask(() => (this.isNoChanges = true))
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Ошибка сохранения работы')
        if (isThrowError) throw new Error('Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    updateScientificPracticalEventInvalid(val) {
      this.scientificPracticalEventInvalid = val
      this.isNoChanges = false
    }
  },

  watch: {
    dataLoaded() {
      this.setWorkListHeight()
    }
  },

  provide: function () {
    return {
      saveWork: this.saveScientificPracticalEvent
    }
  }
}
</script>

<style scoped></style>
